import { Box, BoxProps, ModBox, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { useState } from 'react'
import { Switch } from 'react-native'
import { ExpandAddView } from '../../components/ExpandAddView'
import { useStores } from '../../data/store'
import { ApprovalTypes } from '../../utils/constants'
import { EssAuditTrials } from '../EssAuditTrials'
import { EntityConfigurationApproval } from './EntityConfigurationApproval'
import { MasterApprovals } from './MasterApprovals'

const EntityApprovals = () => {
  const { entMasterApproval, hasEntityConfigApprovals, hasAuditAccess, isAccessConfigPriviledged } = useStores(
    (store) => ({
      entMasterApproval: store.user.getAccessConfig(['entity_config', 'entity_master', 'approve', 'isAccessible']),
      hasEntityConfigApprovals: store.user.getAccessConfig([
        'entity_config',
        'processing_entity_config',
        'approve',
        'isAccessible',
      ]),
      hasAuditAccess: store.user.getAccessConfig([
        'sys_control_config',
        'audit',
        'approval_audit_fetch',
        'isAccessible',
      ]),
      isAccessConfigPriviledged: store.user.getAccessConfig([
        'sys_control_config',
        'audit',
        'approval_audit_privileged',
        'isAccessible',
      ]),
    }),
  )

  const [isUserApprover, setUserApprover] = useState(false)

  const handleToggle = (val: boolean) => {
    setUserApprover(val)
  }

  return (
    <Box>
      <ModBox {...styles.container} show={entMasterApproval}>
        <ExpandAddView title={'Add/Edit Approvals'}>
          <MasterApprovals type={ApprovalTypes.ENTITY} />
        </ExpandAddView>
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox {...styles.container} show={hasEntityConfigApprovals}>
        <ExpandAddView title={'Configurations Approvals'}>
          <EntityConfigurationApproval />
        </ExpandAddView>
      </ModBox>
      <Spacer direction="vertical" size={24} />

      <ModBox
        show={!isAccessConfigPriviledged && hasAuditAccess}
        p={40}
        align={'center'}
        justify={'flex-end'}
        flexDirection={'row'}>
        <TextNew title={'User'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
        <SpacerNew direction={'horizontal'} size={12} />
        <Switch onValueChange={handleToggle} value={isUserApprover} />
        <SpacerNew direction={'horizontal'} size={12} />
        <TextNew title={'Approver'} fontFamily={'jiotype-medium'} fontSize={16} color={'BLACK_21'} />
      </ModBox>
      <Spacer direction="vertical" size={24} />
      <ModBox {...styles.container} show={hasAuditAccess}>
        <ExpandAddView title={'Audit Trail'}>
          <EssAuditTrials type={ApprovalTypes.ENTITY_MASTER_AUD_TRIAL} isApprover={isUserApprover} />
        </ExpandAddView>
      </ModBox>
      <Spacer direction="vertical" size={24} />
    </Box>
  )
}

export default EntityApprovals

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.22,
  shadowRadius: 2.22,
  elevation: 3,
}

const styles = {
  container: {
    ...shadow,
  } as BoxProps,
}
